<template>
  <v-card class="mx-auto" :elevation="isMobile == true ? 0 : 3">
    <v-card v-if="listaDocumentos.length" flat>
      <span
        v-for="(item, index) in listaDocumentos"
        v-bind:key="item._source.edoc + index"
      >
        <v-card tile flat>
          <v-card-title
            class="primary--text font-weight-bold body-1  my-0 py-2"
          >
            {{ item.tituloFormatado }}
            <v-spacer></v-spacer>
            <show-pdf-documento
              :edoc="item._source.edoc"
              :textButton="`e-doc ${item._source.edoc}`"
            />
          </v-card-title>
          <v-card-subtitle
            v-if="item._source.processo"
            class="primary--text  mb-0 pb-0"
          >
            Processo
            <span class="primary--text mb-1 font-weight-bold">
              {{ item._source.processo }}
            </span>
          </v-card-subtitle>
          <v-row
            no-gutters
            class="mx-3 mb-3 text-justify body-2 grey--text text--darken-1"
          >
            <span v-html="item.descricaoFormatada"></span>
          </v-row>
        </v-card>
        <v-divider
          v-if="index < listaDocumentos.length - 1"
          :key="index"
        ></v-divider>
      </span>
    </v-card>
    <v-card v-else flat>
      <h3 class="font-weight-regular grey--text text-center">
        Nenhum resultado encontrado, informe os parâmetros acima e clique em
        buscar.
      </h3>
      <!-- <v-skeleton-loader
        v-bind="attrs"
        type="list-item-avatar-three-line, image, article"
      ></v-skeleton-loader>
      <v-skeleton-loader
        v-bind="attrs"
        type="list-item-avatar-three-line"
      ></v-skeleton-loader> -->
    </v-card>

    <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
      <span slot="no-more" class="font-weight-bold grey--text">
        Todos os registros já foram listados
      </span>
      <span slot="no-results" class="font-weight-bold grey--text">
        Todos os registros já foram listados
      </span>
    </infinite-loading>
  </v-card>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import ShowPdfDocumento from "./ShowPdfDocumento.vue";
export default {
  components: {
    InfiniteLoading,
    ShowPdfDocumento
  },
  props: {
    listaDocumentos: { type: Array },
    novaBusca: { type: Boolean },
    isMobile: { type: Boolean, default: false }
  },
  data() {
    return {
      attrs: {}
    };
  },
  updated: function() {
    if (this.novaBusca) {
      this.$refs.infiniteLoading.stateChanger.reset();
    }
  },
  methods: {
    infiniteHandler($state) {
      if (this.listaDocumentos.length > 0) {
        this.$emit("paginar", $state);
      } else {
        $state.reset();
      }
    }
  }
};
</script>
